import React from 'react'
import I18n from 'lib/i18n'
import { useActions, useValues } from 'kea'
import sceneLogic from '~/scenes/faqs/logic'

export default function Tabs () {
  const { setQuestionTypeParam, setSearchInput } = useActions(sceneLogic)
  const { questionType } = useValues(sceneLogic)
  return (
    <div className='halftabs'>
      <div
        className={`tab1 ${questionType === 'for_teachers' ? 'active' : null}`}
        onClick={() => {
          setQuestionTypeParam('for_teachers')
          setSearchInput('')
        }}
        style={{ cursor: 'pointer' }}
      >
        <span className='ico-teacher'>{I18n.t('activerecord.enums.faq.question_type.for_teachers')}</span>
      </div>
      <div
        className={`tab2 ${questionType === 'for_students' ? 'active' : null}`}
        onClick={() => {
          setQuestionTypeParam('for_students')
          setSearchInput('')
        }}
        style={{ cursor: 'pointer' }}
      >
        <span className='ico-classes'>{I18n.t('activerecord.enums.faq.question_type.for_students')}</span>
      </div>
    </div>
  )
}
